import { Box } from '@mui/material';

import { InfoDialog, Button } from '@occc/ui-design-system';

export type TestAndCreateSFTPCredentialsStatusModalProps = {
  show: boolean;
  onHide: () => void;
  onOkClick: () => void;
  isEntityCreated: boolean;
  isErrorHappened: boolean;
};

export const TestAndCreateSFTPCredentialsStatusModal = ({
  show,
  onHide,
  onOkClick,
  isEntityCreated,
  isErrorHappened,
}: TestAndCreateSFTPCredentialsStatusModalProps) => {
  const title = isErrorHappened
    ? 'SFTP test failed. Please make sure all the SFTP details are correct before trying to save again.'
    : isEntityCreated
    ? 'Credentials were added.'
    : 'SFTP test is in progress...';

  return (
    <InfoDialog
      dialogTitle={title}
      open={show}
      maxWidth='sm'
      hideCloseButton
      onClose={onHide}
      dialogTitleProps={{ sx: { p: 4 } }}
      fullWidth
    >
      {isEntityCreated && (
        <Box p={2} display={'flex'} justifyContent={'flex-end'}>
          <Button variant='contained' onClick={onOkClick}>
            OK
          </Button>
        </Box>
      )}
      {isErrorHappened && (
        <Box p={2} display={'flex'} justifyContent={'flex-end'}>
          <Button variant='contained' onClick={onHide}>
            GO BACK
          </Button>
        </Box>
      )}
    </InfoDialog>
  );
};
